import React from 'react';

const PrivacyPolicy = () => (
  <div className="container my-5">
    <div className="text-center mb-4">
      <h2 className="fw-bold">Privacy Policy</h2>
      <p className="text-muted">Effective Date: April 16, 2025</p>
    </div>

    <p>
      At <strong>PharmaCart</strong>, your privacy is our top priority. We are committed to protecting your personal information and being transparent about how we collect, use, and share your data.
    </p>

    <hr />

    <h5 className="fw-bold mt-4">1. Information We Collect</h5>
    <ul>
      <li><strong>Personal Details:</strong> Name, email, phone number, delivery address.</li>
      <li><strong>Medical Information:</strong> Prescription uploads and order history (only with your consent).</li>
      <li><strong>Payment Information:</strong> Card details and transaction data (secured through trusted payment gateways).</li>
      <li><strong>Usage Data:</strong> Browser type, pages visited, time spent on pages.</li>
    </ul>

    <h5 className="fw-bold mt-4">2. How We Use Your Information</h5>
    <ul>
      <li>To process orders and deliver products to you.</li>
      <li>To verify prescriptions and medical information (where applicable).</li>
      <li>To improve our services, personalize your experience, and troubleshoot issues.</li>
      <li>To send order updates, promotional offers, and health reminders (you can opt out anytime).</li>
    </ul>

    <h5 className="fw-bold mt-4">3. Data Protection & Security</h5>
    <p>
      We implement strict security protocols to protect your data using SSL encryption, secure storage, and access restrictions. Your data is never sold to third parties.
    </p>

    <h5 className="fw-bold mt-4">4. Sharing Your Information</h5>
    <p>
      We only share your information with trusted partners necessary for order fulfillment, such as delivery providers and payment gateways. These partners are bound by confidentiality agreements.
    </p>

    <h5 className="fw-bold mt-4">5. Your Rights</h5>
    <ul>
      <li>Access, update, or delete your personal data anytime.</li>
      <li>Opt-out of marketing communications.</li>
      <li>Request information about how your data is used.</li>
    </ul>

    <h5 className="fw-bold mt-4">6. Cookies</h5>
    <p>
      We use cookies to enhance your browsing experience and analyze site traffic. You can disable cookies through your browser settings.
    </p>

    <h5 className="fw-bold mt-4">7. Changes to This Policy</h5>
    <p>
      We may update our Privacy Policy to reflect changes in technology, regulations, or our practices. Significant updates will be notified on this page.
    </p>

    <h5 className="fw-bold mt-4">8. Contact Us</h5>
    <p>
      For questions, concerns, or to exercise your privacy rights, please email us at <a href="mailto:support@pharmacart.com">support@pharmacart.com</a>.
    </p>

    <div className="alert alert-info mt-5 text-center">
      By using our services, you agree to the collection and use of information in accordance with this policy.
    </div>
  </div>
);

export default PrivacyPolicy;
